<template>
    <form @submit.prevent="callToPickupFLE()">
        <template>
            <template v-if="pickup.completed">
              <div>
                <div class="col-lg-12 text-center">
                  <span class="fa-stack fa-2x" 
                  v-bind:class="{ 'text-success': !pickup.error, 'text-danger': pickup.error }">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-truck fa-stack-1x fa-inverse"></i>
                  </span>
                  <br/>
                  <p v-if="pickup.error" class="text-danger">{{pickup.error}}</p>
                  <p v-else>เงื่อนไขการใช้งาน</p>
                  
                  <div v-if="picker.length">
                    <div v-for="staff in picker" :key="staff.staffName">
                      <p v-if="staff.staffName">ชื่อเจ้าหน้าที่: {{staff.staffName}}</p>
                      <p v-if="staff.staffPhone">เบอร์โทร: {{staff.staffPhone}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="!pickup.showButton">
              <div>
                <p class="text-center">
                  ขณะนี้ยังไม่สามารถกดเรียกขนส่งเข้ารับได้<br/>กรุณากดเรียกใหม่ภายหลังเวลา 14.00 น.
                </p>
              </div>
            </template>
            <template v-else>
              <div class="col-lg-12" >
                <div class="alert alert-shippop-info">
                  เปิดรายการ Booking ของขนส่ง Flash เพื่อให้พนักงานสามารถรับพัสดุได้ 3 กรณีดังนี้
                  <ul>
                    <li>พนักงานสามารถเข้ารับได้หากทำรายการหลัง 14.00น.</li>
                    <li>พนักงานปิด Booking ขณะยังรับงานไม่ครบ</li>
                    <li>Shop สามารถนำพัสดุไปส่งเองที่ขนส่งแฟลช</li>
                  </ul>
                  หมายเหตุ: สามารถกดได้หลัง 14.00น. โดยเงื่อนไขเป็นไปตามที่ขนส่งกำหนด
                </div>
                
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> หมายเลขพัสดุ
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="15"
                    placeholder="หมายเลขพัสดุของขนส่งแฟลช เช่น TH01374NTD7A"
                    :class="{ 'is-invalid': ($v.pickup.trackingCode.$dirty && !$v.pickup.trackingCode.isTrackingCode) || pickup.submitted && ($v.pickup.trackingCode.$invalid) }"
                    v-model="$v.pickup.trackingCode.$model"
                    :readonly="busy"
                  />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>
                    <span class="text-danger">*</span> จำนวนพัสดุ
                  </label>
                  <input
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="จำนวนพัสดุ"
                    :class="{ 'is-invalid': pickup.submitted && $v.pickup.numOfParcel.$invalid }"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    v-model="pickup.numOfParcel"
                    :readonly="busy"
                  />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>
                    รหัสพนักงาน
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="รหัสพนักงาน"
                    :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                    v-model="pickup.staffId"
                    :readonly="busy"
                  />
                </div>
              </div>
            </template>
            
            <div slot="modal-footer" class="w-100 text-right" v-if="!pickup.completed && pickup.showButton">
              <b-button variant="secondary" @click="closeModalPickup">ยกเลิก</b-button>
              <b-button variant="success" type="submit" :disabled="$v.pickup.trackingCode.$invalid || $v.pickup.numOfParcel.$invalid">ยืนยัน</b-button>
            </div>
        </template>
      </form>
</template>

<script>
    import { required } from "vuelidate/lib/validators"
    import validatePop from "../../plugins/validatePop.js"

    export default {
        data() {
            return {
                picker: [],
                pickup: {
                    trackingCode: '',
                    numOfParcel: 1,
                    staffId: '',
                    submitted: false,
                    completed: false,
                    showButton: true //new Date().getHours()>13?true:false
                },
                busy: false,
            }
        },
        validations: {
            pickup: {
                numOfParcel: { required },
                trackingCode: { required, 
                    isTrackingCode(value) {
                    return (
                        /^(TH)\w+$/ig.test(value)
                    );
                    } 
                },
            }
        },
        methods: {
            callToPickupFLE() {
                this.pickup.submitted = true;
                //TH01374NTD7A
                this.busy = true;
                
                this.$http
                    .post(
                    this.$API_URL + "/calltopickup",
                    {
                        tracking_code: this.pickup.trackingCode,
                        num_of_parcel: this.pickup.numOfParcel,
                        staff_info_id: this.pickup.staffId,
                        // courier_code: 'FLE'
                    },
                    {
                        headers: {
                        Token: localStorage.getItem("access_token")
                        }
                    }
                    )
                    .then(res => {
                    const result = res.data;
                    let checkError = validatePop(res);
                    this.pickup.completed = true;
                    this.$v.$reset();
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                        this.$router.push("/logout");
                        }
                        this.pickup.error = checkError.msg;
                        this.busy = false;
                        return false;
                    }
                    if (result.status) {
                        let courierPicker = result.data.data
                        if (courierPicker.length) {
                        courierPicker = this.IsJsonString(result.data.data.response_data)?JSON.parse(result.data.data.response_data):courierPicker;
                        } else {
                        courierPicker = this.IsJsonString(courierPicker.response_data)?JSON.parse(courierPicker.response_data).data:courierPicker;
                        }
                        this.picker = []; 
                        courierPicker.map((x) => {
                        const pickupInfo = x.pickupInfo;
                        this.picker.push({
                            staffName: pickupInfo.staffName,
                            staffPhone: pickupInfo.staffPhone,
                            created_at: result.data.data.created_at
                        })
                        })
                    }

                    this.busy = false
                    })
            },
            closeModalPickup() {
                this.$emit('cancel')
            }
        }
    }
</script>